import {emptyArray} from "js-vextensions";
import {CreateAccessor, GetDocs, GetDoc} from "mobx-graphlink";
import {Entity} from "./entities/@Entity.js";
import {Me, MeID} from "./users.js";
import {EntityPool} from "../../Store/main/content.js";
import {store} from "../../Store/index.js";

export const GetEntity = CreateAccessor((id: string|n): Entity|n=>{
	//return GetDoc({}, a=>a.entities.get(id!))?.Cast(Entity);
	return GetEntities().find(a=>a.id == id) ?? null; // probably temp; depending on GetEntities(), so we don't have to re-implement handling of both online and local entities
});
export const GetEntities = CreateAccessor((pool?: EntityPool|n): Entity[]=>{
	const result = [] as Entity[];

	// web
	// ==========

	if (pool == EntityPool.online || pool == null) {
		//new WhereOp("visibleToGroups", "array-contains-any", [...(MeID() ? [MeID()] : []), "public"]),
		// todo: probably implement this more efficiently (eg. implement a containsAny filter in mobx-graphlink)
		const result_web_public = GetDocs({
			params: {filter: {visibleToGroups: {containsAll: ["public"]}}},
		}, a=>a.entities).map(a=>a?.Cast(Entity));
		const result_web_private = MeID() == null ? [] : GetDocs({
			params: {filter: {visibleToGroups: {containsAll: [MeID()]}}},
		}, a=>a.entities).map(a=>a?.Cast(Entity));
		const result_web = [...result_web_public, ...result_web_private.filter(a=>!result_web_public.Any(b=>b.id == a.id))];
		result.push(...result_web);
	}

	// local
	// ==========

	if (pool == EntityPool.local || pool == null) {
		const result_local = store.main.content.entities.entities_local;
		result.push(...result_local);
	}

	return result;
});
export const GetEntities_WithUserTag = CreateAccessor((tagName: string|n): Entity[]=>{
	const entities = GetEntities();
	const userEntityTags = Me()?.entityTags?.entities ?? {};
	return entities.filter(a=>userEntityTags[a.id]?.includes(tagName as any));
});
export const GetEntities_WithUserTags = CreateAccessor((tagNames: string[]): Entity[]=>{
	const entities = GetEntities();
	const userEntityTags = Me()?.entityTags?.entities ?? {};
	return entities.filter(a=>{
		const tags = userEntityTags[a.id] ?? emptyArray;
		return tagNames.every(tagName=>tags.includes(tagName));
	});
});

export function ExcludeMetaEntitiesFromList(entities: Entity[]) {
	return entities.filter(a=>!IsMetaEntity(a));
}
export function IsMetaEntity(entity: Entity) {
	return entity.name.startsWith("[") && entity.name.endsWith("]");
}

export function IsMetaTerm(term: string) {
	return term.startsWith("[") && term.endsWith("]");
}